import { render, staticRenderFns } from "./BarraLateralComponent.vue?vue&type=template&id=6d6e2a7a&scoped=true"
import script from "./BarraLateralComponent.vue?vue&type=script&lang=js"
export * from "./BarraLateralComponent.vue?vue&type=script&lang=js"
import style0 from "./BarraLateralComponent.vue?vue&type=style&index=0&id=6d6e2a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e2a7a",
  null
  
)

export default component.exports